<template>
    <div id='intro'>
        <!------------------------------關於我們開始------------------------------>
        <section class="cm-intro-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>


            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('footer.Intro.Title')}}
                </div>
            </div>

            <div class="cm-intro-container">
                <div class="d-flex justify-content-center py-3 cm-intro-title">{{$t('footer.Intro.Message1')}}</div>
                <p>{{$t('footer.Intro.Message2')}}</p>
                <div class="mb-3 pb-3 border-bottom border-white">
                    <table class="cm-intro-table">
                        <tbody>
                            <tr>
                                <td>{{$t('footer.Intro.Table.Company.Item')}}</td>
                                <td>{{$t('footer.Intro.Table.Company.Content')}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('footer.Intro.Table.DateOfFounding.Item')}}</td>
                                <td>{{$t('footer.Intro.Table.DateOfFounding.Content')}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('footer.Intro.Table.ScopeOfBusiness.Item')}}</td>
                                <td>{{$t('footer.Intro.Table.ScopeOfBusiness.Content')}}</td>
                            </tr>
                            <tr>
                                <td>{{$t('footer.Intro.Table.Region.Item')}}</td>
                                <td>{{$t('footer.Intro.Table.Region.Content')}}</td>
                            </tr>
                            <tr class="d-none d-xl-table-row">
                                <td>{{$t('footer.Intro.Table.PlatformWebsite.Item')}}</td>
                                <td>
                                    <a :href="$t('footer.Intro.Table.PlatformWebsite.Content')">
                                        {{$t('footer.Intro.Table.PlatformWebsite.Content')}}
                                    </a>
                                </td>
                            </tr>
                            <tr class="d-none d-xl-table-row">
                                <td>{{$t('footer.Intro.Table.YouTube.Item')}}</td>
                                <td>
                                    <a :href="$t('footer.Intro.Table.YouTube.Content')">
                                        {{$t('footer.Intro.Table.YouTube.Content')}}
                                    </a>
                                </td>
                            </tr>
                            <tr class="d-none d-xl-table-row">
                                <td>{{$t('footer.Intro.Table.FaceBook.Item')}}</td>
                                <td>
                                    <a :href="$t('footer.Intro.Table.FaceBook.Content')">
                                        {{$t('footer.Intro.Table.FaceBook.Content')}}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="d-xl-none" style="word-wrap: break-word;">
                        <br>
                        <div class="row no-gutters">
                            <div class="col-12">{{$t('footer.Intro.Table.PlatformWebsite.Item')}}</div>
                            <div class="col-12">
                                <a :href="$t('footer.Intro.Table.PlatformWebsite.Content')">
                                    {{$t('footer.Intro.Table.PlatformWebsite.Content')}}
                                </a>
                            </div>
                        </div>
                        <br />
                        <div class="row no-gutters">
                            <div class="col-12">{{$t('footer.Intro.Table.YouTube.Item')}}</div>
                            <div class="col-12">
                                <a :href="$t('footer.Intro.Table.YouTube.Content')">
                                    {{$t('footer.Intro.Table.YouTube.Content')}}
                                </a>
                            </div>
                        </div>
                        <br />
                        <div class="row no-gutters">
                            <div class="col-12">{{$t('footer.Intro.Table.FaceBook.Item')}}</div>
                            <div class="col-12">
                                <a :href="$t('footer.Intro.Table.FaceBook.Content')">
                                    {{$t('footer.Intro.Table.FaceBook.Content')}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <img :src="require('@/assets/images/footer/' + $t('footer.Intro.ImgName'))" class="img-fluid" alt="Responsive image">
            </div>
            <div class="cm-intro-banner-line"></div>
        </section>
        <!------------------------------關於我們結束------------------------------>
    </div>
</template>

<script>
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'
export default {
    data() {
        return {
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg")
        }
    },
    mounted() {
        this.updateTopBackgroundImg();
        document.documentElement.scrollTop = 0;
        
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_INTRO, function(i18n) {
            self.updateTopBackgroundImg(i18n);
        })
    },
    methods: {
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        }
    }
}
</script>